export enum TransportPlannerProfileEndpoint {
  Base = '/tp',
  Profiles = '/profiles',
  Clone = '/clone',
  Profile = '/profile',
}
